"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Forms = require("../../../components/Forms");
var _helpers = require("../../../helpers");
var _reactstrap = require("reactstrap");
var _moment = _interopRequireDefault(require("moment"));
var _uuid = _interopRequireDefault(require("uuid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-restricted-globals */
class DownloadWithDate extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onStartDateChange", e => {
      {
        e.preventDefault && e.preventDefault();
      }
      if (e <= this.state.endDate) {
        let date = (0, _moment.default)(e);
        let startDate = date.toISOString();
        let startDateDisplay = date.format("DD.MM.YYYY");
        this.setState({
          startDate: startDate,
          startDateDisplay: startDateDisplay,
          startCalendarOpen: false
        });
      }
    });
    _defineProperty(this, "onEndDateChange", e => {
      {
        e.preventDefault && e.preventDefault();
      }
      if (e >= this.state.startDate) {
        let date = (0, _helpers.getEndOfDay)(e);
        let endDate = date.toISOString();
        let endDateDisplay = date.format("DD.MM.YYYY");
        this.setState({
          endDate: endDate,
          endDateDisplay: endDateDisplay,
          endCalendarOpen: false
        });
      }
    });
    _defineProperty(this, "toggleStartCalendar", () => {
      this.setState({
        startCalendarOpen: this.state.startCalendarOpen ? false : true,
        endCalendarOpen: false
      });
    });
    _defineProperty(this, "toggleEndCalendar", () => {
      this.setState({
        endCalendarOpen: this.state.endCalendarOpen ? false : true,
        startCalendarOpen: false
      });
    });
    _defineProperty(this, "handleShortcut", shortcut => {
      let dateObject = (0, _helpers.getTimeSpan)(shortcut.function);
      this.setState({
        startDate: dateObject.startDate,
        startDateDisplay: (0, _moment.default)(dateObject.startDate).format("DD.MM.YYYY"),
        startCalendarOpen: false,
        endDate: dateObject.endDate,
        endDateDisplay: (0, _moment.default)(dateObject.endDate).format("DD.MM.YYYY"),
        endCalendarOpen: false
      });
    });
    _defineProperty(this, "convertToCSV", objArray => {
      let array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      let str = "";
      let keysArray = [];

      // Get the unique keys

      keysArray = Object.keys(Object.assign({}, ...array));
      let line = "";
      for (let i = 0; i < keysArray.length; i++) {
        // Parsing the keys in the first line of the csv

        line += keysArray[i];
        if (i < keysArray.length - 1) {
          line += ",";
        }
      }
      str += line + "\r\n";

      // Parsing the values

      for (let i = 0; i < array.length; i++) {
        // For every element in the array, a new line

        let line = "";
        Object.values(keysArray).forEach(function (globalKey, index) {
          Object.entries(array[i]).forEach(([key, value]) => {
            // For every item (key, value)

            if (globalKey === key) {
              line += value;
            }
          });
          if (index < keysArray.length - 1) {
            line += ",";
          }
        });
        str += line + "\r\n";
      }
      return str;
    });
    _defineProperty(this, "onDownload", () => {
      const {
        dataset
      } = this.props;
      let params = {
        startDate: this.state.startDate,
        endDate: this.state.endDate
      };
      this.props.getResult(dataset.id, params).then(result => {
        if (result.data) {
          let formattedData;
          if (!result.format || result.format === "json") {
            formattedData = JSON.stringify(result.data);
          } else if (result.format === "csv") {
            formattedData = this.convertToCSV(result.data);
          }
          let blob = new Blob([formattedData], {
            type: result.mime_type || "text/plain"
          });
          let download_link = document.createElement("a");
          download_link.download = result.file_name;
          download_link.href = window.URL.createObjectURL(blob);
          download_link.onClick = function (e) {
            let that = this;
            setTimeout(function () {
              window.URL.revokeObjectURL(that.href);
            }, 1500);
          };
          download_link.click();
          download_link.remove();
          let url = URL.createObjectURL(blob);
          document.getElementById("download_button").href = url;
          document.getElementById("download_button").download = result.file_name || "data.txt";
        }
      });
    });
    let _dateObject;
    if (props.dataset.shortcuts) {
      _dateObject = (0, _helpers.getTimeSpan)(props.dataset.shortcuts[0].function);
    } else {
      _dateObject = (0, _helpers.getTimeSpan)("TODAY");
    }
    this.state = {
      startDate: _dateObject.startDate,
      startDateDisplay: (0, _moment.default)(_dateObject.startDate).format("DD.MM.YYYY"),
      startCalendarOpen: false,
      endDate: _dateObject.endDate,
      endDateDisplay: (0, _moment.default)(_dateObject.endDate).format("DD.MM.YYYY"),
      endCalendarOpen: false
    };
  }
  componentDidMount() {
    document.addEventListener("click", () => {
      if (!event.target.closest(".calendarWidget") && !event.target.closest(".widgetLink")) {
        this.setState({
          startCalendarOpen: false,
          endCalendarOpen: false
        });
      }
    }, false);
  }
  render() {
    const {
      dataset
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card rounded shadow mb-3 p-5",
      style: {
        height: "25rem"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/_react.default.createElement("h4", {
      className: "card-title mb-4"
    }, dataset.title), /*#__PURE__*/_react.default.createElement("p", {
      className: "text-muted mb-5"
    }, dataset.description), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-text mt-5"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "container-fluid"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row align-items-start"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-4 pl-0 pt-1"
    }, dataset.fetching ? /*#__PURE__*/_react.default.createElement("button", {
      id: "download_button",
      onClick: this.onDownload,
      disabled: true,
      className: "btn btn-primary mr-5"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "spinner-border spinner-border-sm mr-2",
      role: "status",
      "aria-hidden": "true"
    }), "Gathering...") : /*#__PURE__*/_react.default.createElement("button", {
      id: "download_button",
      onClick: this.onDownload,
      className: "btn btn-primary mr-5"
    }, "Download")), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-4"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("small", {
      className: "text-muted text-uppercase"
    }, "Start date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "widgetLink",
      onClick: this.toggleStartCalendar
    }, /*#__PURE__*/_react.default.createElement("h5", null, this.state.startDateDisplay)), this.state.startCalendarOpen && /*#__PURE__*/_react.default.createElement(_reactstrap.FormGroup, {
      className: "shadow calendarWidget",
      style: {
        zIndex: "999"
      }
    }, /*#__PURE__*/_react.default.createElement(_Forms.Date, {
      value: this.state.startDate,
      onChange: e => this.onStartDateChange(e),
      maxDate: this.state.endDate
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-4"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("small", {
      className: "text-muted text-uppercase"
    }, "End date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "widgetLink",
      onClick: this.toggleEndCalendar
    }, /*#__PURE__*/_react.default.createElement("h5", null, this.state.endDateDisplay)), this.state.endCalendarOpen && /*#__PURE__*/_react.default.createElement(_reactstrap.FormGroup, {
      className: "shadow calendarWidget",
      style: {
        zIndex: "999"
      }
    }, /*#__PURE__*/_react.default.createElement(_Forms.Date, {
      value: this.state.endDate,
      onChange: e => this.onEndDateChange(e),
      minDate: this.state.startDate
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row mt-5 mb-0",
      style: {
        zIndex: "2",
        position: "absolute",
        bottom: "4rem"
      }
    }, dataset.shortcuts && dataset.shortcuts.map(shortcut => /*#__PURE__*/_react.default.createElement("button", {
      key: _uuid.default.v4(),
      type: "submit",
      onClick: () => this.handleShortcut(shortcut),
      className: "btn btn-secondary mr-5"
    }, shortcut.name)))))));
  }
}
var _default = exports.default = DownloadWithDate;
module.exports = exports.default;